import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const GET_BENUTZER_LISTE_ADMIN2 = '[BenutzerverwaltungModul] GetBenutzerListeAdmin2 laden';
export const GET_BENUTZER_LISTE_ADMIN2_AUSFUEHREN = '[BenutzerverwaltungModul] GetBenutzerListeAdmin2 ausführen';
export const GET_BENUTZER_LISTE_ADMIN2_ERFOLGREICH = '[BenutzerverwaltungModul] GetBenutzerListeAdmin2 laden erfolgreich';
export const GET_BENUTZER_LISTE_ADMIN2_FEHLER = '[BenutzerverwaltungModul] GetBenutzerListeAdmin2 Ladefehler';
export const GET_BENUTZER_LISTE_ADMIN2_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] GetBenutzerListeAdmin2 nicht ausgeführt (evtl. Offline)';


export class GetBenutzerListeAdmin2Action implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN2;
        constructor(public optPayload: any = null) {}
    }
export class GetBenutzerListeAdmin2AusfuehrenAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN2_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetBenutzerListeAdmin2ErfolgreichAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN2_ERFOLGREICH;
        constructor(public payload: Array<api.BenutzerForAdmin>, public optPayload: any = null) {}
    }
export class GetBenutzerListeAdmin2FehlerAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN2_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetBenutzerListeAdmin2NichtAusgefuehrtAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN2_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungQueryBenutzerListeAdmin2Actions =
    GetBenutzerListeAdmin2Action
    | GetBenutzerListeAdmin2AusfuehrenAction
    | GetBenutzerListeAdmin2ErfolgreichAction
    | GetBenutzerListeAdmin2FehlerAction
    | GetBenutzerListeAdmin2NichtAusgefuehrtAction
    ;
